import React, { useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { getUrlParameter, insertUrlParam } from "src/utils/urlQueryHandle";
import "./index.scss";

interface IProps {
  callback: (indexActive: number) => void;
  style?: React.CSSProperties;
}

function ListTabsComponent({ callback, style }: IProps) {
  const iQs = getUrlParameter("reservation_list_tab_active");
  const [tabs, setTabs] = useState(iQs ? Number(iQs) : 0);
  const { t } = useTranslation();
  const listTabs = [
    {
      name: t("reservation_list.tabs_1"),
    },
    {
      name: t("reservation_list.tabs_2"),
    },
  ];

  return (
    <div
      className={`list-tabs${isMobile ? "-mobile" : ""}`}
      style={{ ...style }}
    >
      {listTabs.map((tab, index) => {
        return (
          <div
            key={index}
            className={`tabs-${index + 1} ${
              tabs === index ? "active" : "non-active"
            }`}
            onClick={() => {
              setTabs(index);
              callback(index);
              insertUrlParam("reservation_list_tab_active", `${index}`);
            }}
          >
            {tab.name}
          </div>
        );
      })}
    </div>
  );
}

export default ListTabsComponent;
